import React from 'react'

const weeks = [
   {
      week: "Semaine 1",
      title: "Introduction à Python",
      desc: "Variables, conditions, boucles, fonctions. Exercices pratiques et quiz.",
      color: "bg-purple-3",
      ageGroups: [
        "👦 12-15 ans: Initiation ludique avec des projets simples",
        "👨‍🎓 16-18 ans: Fondamentaux solides avec exercices pratiques",
        "👨‍💼 Adultes: Approche orientée projets concrets"
      ]
   },
   {
      week: "Semaine 2",
      title: "Approfondissement Python",
      desc: "Structures de données, fichiers, fonctions avancées et PyScript.",
      color: "bg-light-2",
      ageGroups: [
        "👦 12-15 ans: Création d'applications simples avec PyScript",
        "👨‍🎓 16-18 ans: Manipulation de données et algorithmes de base",
        "👨‍💼 Adultes: Développement d'applications web fonctionnelles"
      ]
   },
   {
      week: "Semaine 3",
      title: "Introduction au Web",
      desc: "HTML/CSS, responsive design, projet personnel avec Python.",
      color: "bg-light-3",
      ageGroups: [
        "👦 12-15 ans: Création d'une page web personnelle simple",
        "👨‍🎓 16-18 ans: Site portfolio avec intégration Python",
        "👨‍💼 Adultes: Application web complète avec backend Python"
      ]
   },
   {
      week: "Semaine 4",
      title: "Finalisation & Présentation",
      desc: "Amélioration, ajout de fonctionnalités, préparation d'une démo finale.",
      color: "bg-red-3",
      ageGroups: [
        "👦 12-15 ans: Présentation d'un projet créatif simple",
        "👨‍🎓 16-18 ans: Démo d'une application web fonctionnelle",
        "👨‍💼 Adultes: Présentation d'un projet professionnel complet"
      ]
   }
]

function ProgramDétaillé() {
   return (
      <section className="py-20 bg-light-6">
         <div className="max-w-6xl mx-auto px-6">
            <h2 className="text-title font-bold text-dark-2 text-center mb-4">📘 Le parcours en 4 semaines</h2>
            <p className="text-center text-dark-3 mb-10 max-w-3xl mx-auto">
               Programme adapté pour trois tranches d'âge avec des approches pédagogiques différenciées
            </p>
            
            {/* Légende des tranches d'âge */}
            <div className="flex flex-wrap justify-center gap-4 mb-8">
               <div className="flex items-center">
                  <span className="text-xl mr-2">👦</span>
                  <span className="text-sm font-medium">12-15 ans</span>
               </div>
               <div className="flex items-center">
                  <span className="text-xl mr-2">👨‍🎓</span>
                  <span className="text-sm font-medium">16-18 ans</span>
               </div>
               <div className="flex items-center">
                  <span className="text-xl mr-2">👨‍💼</span>
                  <span className="text-sm font-medium">Adultes</span>
               </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
               {weeks.map((week, idx) => (
                  <div
                     key={idx}
                     className={`${week.color} rounded-2xl p-8 border border-light-2`}
                  >
                     <h3 className="text-subtitle font-semibold text-dark-4 mb-1">{week.week}</h3>
                     <h4 className="text-lg font-bold text-dark-2 mb-2">{week.title}</h4>
                     <p className="text-dark-3 text-sm md:text-base leading-relaxed mb-4">{week.desc}</p>
                     
                     <div className="mt-4 pt-4 border-t border-gray-200">
                        <h5 className="font-semibold text-dark-2 mb-2">Approche par tranche d'âge:</h5>
                        <ul className="space-y-2">
                           {week.ageGroups.map((group, i) => (
                              <li key={i} className="text-sm text-dark-3">{group}</li>
                           ))}
                        </ul>
                     </div>
                  </div>
               ))}
            </div>
         </div>
      </section>
   )
}

export default ProgramDétaillé